<script>
  import PauseOutline from "@/components/partials/icons/PauseOutline.vue";

  export default {
    name: "ProfileCompletionPending",
    components: { PauseOutline },
  };
</script>

<template>
  <div
    class="bg-accent-3-100 p-y-3 p-x-6 radius-16 d-flex align-items-center gap-6"
  >
    <PauseOutline color="var(--accent-3-700)" />
    <p class="text-accent-3-700 p-small-medium">
      {{ $t("labels.profileCompletionPending") }}
    </p>
  </div>
</template>
